export enum ClientRequestMethod {
    GET = 'GET',
    POST = 'POST',
    PUT = 'PUT',
    DELETE = 'DELETE',
    OPTIONS = 'OPTIONS',
    HEAD = 'HEAD',
    PATCH = 'PATCH',
}

export enum ResponseContentType {
    ARRAYBUFFER = 'arraybuffer',
    BLOB = 'blob',
    JSON = 'json',
    TEXT = 'text'
}
